class GlobalHelper {
  generateHashFromString(str: string) {
    return str.split('').reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  }

  getUrlQueryParams() {
    const urlQueryParams = new URLSearchParams(window.location.search);
    const urlQueryParamsObj = Object.fromEntries(urlQueryParams.entries());
    return JSON.parse(JSON.stringify(urlQueryParamsObj));
  }

  getUrlQueryParameter(paramName: string): string {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(paramName);
  }

  setUrlQueryParameter(paramName: string, paramValue: string) {
    const url = new URL(window.location);
    url.searchParams.set(paramName, paramValue);
    window.history.pushState({}, '', url);
  }

  paramsToQueryString(params: { string: any }) {
    let queryParamsString = '';
    if (params !== undefined && Object.keys(params).length > 0) {
      let isFistIteration = true;
      Object.keys(params).forEach((key) => {
        queryParamsString += `${(isFistIteration ? '?' : '&') + key}=${params[key]}`;
        isFistIteration = false;
      });
    }
    return queryParamsString;
  }

  slugify(string: string) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
    const p = new RegExp(a.split('').join('|'), 'g');

    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }

  setCookie(name: string, value: string, hours = 99999) {
    const now = new Date();
    const time = now.getTime();
    const expireTime = time + 1000 * 3600 * hours;
    now.setTime(expireTime);

    document.cookie = name + '=' + value + ';expires=' + now.toString() + ';path=/;domain=' + window.location.hostname + ';';
  }

  readCookie(name: string) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim(); // Ensure trimming any leading spaces
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  dynamicModalLogic() {
    const dynamicModal = document.querySelector('#dynamic-modal');

    if (dynamicModal !== null) {
      const dynamicModalCloseElements = ['.dynamic-modal-backdrop', '.dynamic-modal-close'];
      dynamicModalCloseElements.forEach((element) => {
        dynamicModal.querySelector(element).addEventListener('click', () => {
          dynamicModal.classList.remove('opacity-100', 'pointer-events-auto');

          dynamicModal.querySelector('iframe')?.setAttribute('src', '');
        });
      });
    }
  }

  roundToDecimals(value: number, decimals: number): number {
    return Number(value.toFixed(decimals));
  }
}

export default new GlobalHelper();
